const mFeedAssetsContentModalDuplicate = {
  mFeedAssetsContentModalDuplicate: {
    alerts: {
      createProyectoClonar: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El curso fue duplicado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'DUPLICAR',

    messageDelete: {
      element: 'Se duplicará el curso',
      options: 'y todas sus características.'
    },

    title: 'Duplicar Curso'
  }
}

export default mFeedAssetsContentModalDuplicate
